// 百日行动
import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, ListView, Icon } from 'antd-mobile';
import moment from 'moment';

import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from './api';

import './index.less';

class PeaceActivity extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            loading:true,
            urlOps: {},
            statistics: {},
        };
    }

    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            const that = this;
            that.setState({
                urlOps: ops
            },()=>{
                // setTimeout(()=>{
                    that.selectAnnualSafeStatistics();
                // },2000);
            });
        }
    }

    componentWillMount() {
    }

    selectAnnualSafeStatistics(){
        const {urlOps} = this.state;
        post({
            url:api.selectAnnualSafeStatistics + '?app_stoken=' + urlOps.app_stoken,
            data:{}
          }).then((res) => {

            this.setState({
                statistics:res.data || {}
            },()=>{
                
                const that = this;
                setTimeout(()=>{
                    that.setState({
                        loading:false,
                    })
                },2000);
            });
          });
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }

    // 查违章
    getViolations(){
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                window.webkit.messageHandlers.violations.postMessage('');
            }
        } else {
            if(window.huilian){
                window.huilian.violations('');
               
            }
        }
    }

    render() {
        
        const { statistics, loading } = this.state;

        return (
            <div className='activity_result'>
                <div className="top">
                    <div className='success'>
                        <div className='icon'></div>
                        <div className='orange_text'>
                            恭喜您!报名成功!
                        </div>
                        <div className='grey_text'>
                            活动期间保持0违章、0出险记录，<br></br>
                            可参与瓜分2万元大礼包！
                        </div>

                        <div className='content'>
                            <div className='top'>
                                <span className='top-title'>2022年度安全数据回顾</span>
                            </div>
                            <div className='line'></div>
                            {
                                loading ? <div>
                                    <div className='loading'>
                                        <div className='loading-bg'></div>
                                    </div>
                                    <div className='loading_text'>正在智能分析中...</div>
                                </div> : <div>
                                    <div className='safe'>
                                        <div className='text'>安全表现</div>
                                        <div className="level mt-10">
                                            {
                                                [1,2,3,4,5].map((d,i)=>{
                                                    return <div key={i} className={`star ${statistics.level >= d ? 'star_full' : ''} 
                                                    ${statistics.level > d && statistics.level < d+1 ? 'star_half' : ''}
                                                    ${statistics.level < d ? 'star_empty' : ''} `}></div>
                                                })
                                            }
                                            {/* <div className="star star_full"></div>
                                            <div className="star star_full"></div>
                                            <div className="star star_full"></div>
                                            <div className="star star_half"></div>
                                            <div className="star star_empty"></div> */}
                                        </div>
                                        <div className='text mt-10'>江湖封号</div>
                                        <div className='title mt-10'>“{statistics.title}”</div>
                                    </div>
                                    <div className='line'></div>
                                    <div className='list'>
                                        <div className='left'>待处理违章</div>
                                        <div className={`right ${statistics.violationNumber > 0 ? 'red' : 'grey'}`}>{statistics.violationNumber || 0}</div>
                                    </div>
                                    <div className='list'>
                                        <div className='left'>出险次数</div>
                                        <div className={`right ${statistics.violationNumber > 0 ? 'red' : 'grey'}`}>{statistics.insuranceNumber || 0}</div>
                                    </div>
                                    <div className='line'></div>
                                    <div className='message'>{statistics.content}</div>
                                    {
                                        statistics.violationNumber > 0 ? 
                                        <div className='link' onClick={()=>this.getViolations()}>查看相关违章记录</div> : ''
                                    }
                                    <div className='total'>*数据统计截止到2022年10月31日</div> 
                                </div>
                            }
                             
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default PeaceActivity;


// WEBPACK FOOTER //
// ./src/peaceSharkIndex/index/activity.js